module.exports = __webpack_public_path__ + "dc11cdb335c2096a56798ef3aa3e8dca.jpg";